jQuery(function ($) {
    $('.gform_wrapper').on('click', '.avaniko-gf-primary-button', function () {
        var $button = $(this);
        $button.find('.avaniko-gf-primary-button-text').addClass('d-none');
        $button.find('.avaniko-gf-primary-button-loader').removeClass('d-none');
    });

    jQuery(document).on('gform_post_render', function (event, formId) {
        if (Number(formId) === 3) {
            $('.avaniko-gf-primary-button-text').removeClass('d-none');
            $('.avaniko-gf-primary-button-loader').addClass('d-none');
        }
    });

    jQuery(document).on("gform_page_loaded", function (event, formId, current_page) {
        if (Number(formId) === 4) {
            // Progress Bar.
            if ($("#gf_progressbar_wrapper_4").length > 0) {
                var $progressBar = $(".questionnaire-progress-bar");
                var progress = $("#gf_progressbar_wrapper_4 .gf_progressbar_percentage span").text();
                $progressBar.removeClass("d-none");
                $progressBar.find(".questionnaire-progress-bar-val").text(progress);
                $progressBar.find(".questionnaire-progress-bar-in").css("width", progress);
            }

            // Progress navigation.
            var dataVolumeInitPage = 4;
            var validateBusinessInitPage = 5;
            var leadFormInitPage = 26;
            var $progressNav = $(".questionnaire-progress-nav");

            if (Number(current_page) >= dataVolumeInitPage) {
                $progressNav.find("li:eq(0)").addClass("completed");
                $progressNav.find("li:eq(1)").addClass("active");

                if (Number(current_page) >= validateBusinessInitPage) {
                    $progressNav.find("li:eq(1)").addClass("completed");
                    $progressNav.find("li:eq(2)").addClass("active");

                    if (Number(current_page) >= leadFormInitPage) {
                        $progressNav.find("li:eq(2)").addClass("completed");
                    } else {
                        $progressNav.find("li:eq(2)").removeClass("completed")
                    }
                } else {
                    $progressNav.find("li:eq(1)").removeClass("completed");
                    $progressNav.find("li:eq(2)").removeClass("active completed");
                }
            } else {
                $progressNav.find("li").removeClass("active completed");
                $progressNav.find("li:eq(0)").addClass("active");
            }
        }
    });

    var scoreProgressOptions = {
        max: 100,
        value: 0,
        textFormat: function (value) {
            return '<tspan x="50" dy="-1.5em">YOUR SCORE</tspan>' + '<tspan x="50" dy="1.05em">' + value + '%</tspan>';
        }
    };
    $(".questionnaire-assessment-score").circleProgress(scoreProgressOptions);

    jQuery(document).on('gform_confirmation_loaded', function (event, formId) {
        if (Number(formId) === 4) {
            $(".questionnaire-progress-wrapper").addClass("d-none");
            $(".questionnaire-assessment-score-wrapper").removeClass("d-none");
            $(".questionnaire-left").addClass("score-calculated");
            $(".questionnaire-try-again-button").removeClass("d-none");
            var assessmentScore = $(".questionnaire-assessment-confirmation-wrapper").data('score');
            scoreProgressOptions.value = Number(assessmentScore);
            $(".questionnaire-assessment-score").circleProgress(scoreProgressOptions);
        }
    });
});